export default [
  {
    path: '/',
    component: 'Home',
    meta: {
      title: 'Home',
      icon: 'fa fa-address-card'
    },
    hidden: false,
    leaf: true, // 只有一个节点
    children: [
      {
        path: '/Dashboard',
        component: 'Dashboard',
        meta: {
          title: '首页',
          icon: 'iconfont icon-gongzuotai'
        }
      }
    ]
  },
  {
    path: '/',
    component: 'Home',
    meta: {
      title: '库存初始化流程',
      icon: 'iconfont icon-renwuliucheng'
    },
    hidden: false,
    leaf: false,
    children: [
      {
        path: '/Kccshlc',
        component: 'Kccshlc',
        meta: {
          title: '库存初始化流程',
          icon: 'el-icon-star-on'
        }
      }
    ]
  },
  {
    path: '/',
    component: 'Home',
    hidden: true,
    leaf: true, // 只有一个节点
    meta: {
      title: 'Home',
      icon: 'fa fa-address-card'
    },
    children: [
      {
        path: '/Spload',
        component: 'Spload',
        meta: {
          title: '入网审批中',
          icon: 'el-icon-star-on'
        }
      }
    ]
  },
  {
    path: '/',
    component: 'Home',
    hidden: true,
    leaf: true, // 只有一个节点
    meta: {
      title: 'Home',
      icon: 'fa fa-address-card'
    },
    children: [
      {
        path: '/personalCenter',
        name: 'PersonalCenter',
        component: 'personalCenter',
        meta: {
          title: '个人中心',
          icon: 'iconfont icon-baobiao'
        }
      }
    ]
  },
  {
    path: '/',
    component: 'Home',
    hidden: true,
    leaf: true, // 只有一个节点
    meta: {
      title: 'Home',
      icon: 'fa fa-address-card'
    },
    children: [
      {
        path: '/Spfail',
        component: 'Spfail',
        meta: {
          title: '入网审批失败',
          icon: 'el-icon-star-on'
        }
      }
    ]
  },
  {
    path: '/',
    component: 'Home',
    meta: {
      title: 'Home',
      icon: 'fa fa-address-card'
    },
    hidden: true,
    leaf: true, // 只有一个节点
    children: [
      {
        path: '/Rwsq',
        component: 'Rwsq',
        meta: {
          title: '入网申请',
          icon: 'el-icon-star-on'
        }
      }
    ]
  },
  {
    path: '/',
    component: 'Home',
    meta: {
      title: 'Home',
      icon: 'fa fa-address-card'
    },
    hidden: true,
    leaf: true, // 只有一个节点
    children: [
      {
        path: '/Rwsqstep',
        component: 'Rwsqstep',
        meta: {
          title: '入网申请步骤',
          icon: 'el-icon-star-on'
        }
      }
    ]
  },
  {
    path: '/',
    component: 'Home',
    meta: {
      title: 'Home',
      icon: 'fa fa-address-card'
    },
    hidden: true,
    leaf: true, // 只有一个节点
    children: [
      {
        path: '/RwsqStepAdmin',
        component: 'RwsqStepAdmin',
        meta: {
          title: '入网申请步骤',
          icon: 'el-icon-star-on'
        }
      }
    ]
  },
  {
    path: '/',
    component: 'Home',
    meta: {
      title: '单位信息',
      icon: 'iconfont icon-qiye'
    },
    hidden: false,
    leaf: false,
    children: [
      {
        path: '/Cyry',
        component: 'Cyry',
        meta: {
          title: '从业人员',
          icon: 'el-icon-star-on'
        }
      },
      {
        path: '/Qyjbxx',
        component: 'Qyjbxx',
        meta: {
          title: '单位基本信息',
          icon: 'el-icon-star-on'
        }
      },
      {
        path: '/Ckgl',
        component: 'Ckgl',
        meta: {
          title: '仓库管理',
          icon: 'el-icon-star-on'
        }
      },
      {
        name: 'Qyxxbg',
        path: '/Qyxxbg',
        component: 'Qyxxbg',
        meta: {
          title: '单位信息变更',
          icon: 'el-icon-star-on'
        }
      },
      {
        path: '/Cl',
        component: 'Cl',
        meta: {
          title: '车辆',
          icon: 'el-icon-star-on'
        }
      },
      {
        path: '/Wldw',
        component: 'Wldw',
        meta: {
          title: '往来单位',
          icon: 'el-icon-star-on'
        }
      },
      {
        path: '/Gly',
        component: 'Gly',
        meta: {
          title: '信息员',
          icon: 'el-icon-star-on'
        }
      },

      {
        path: '/Qyzz',
        name: 'Qyzz',
        component: 'Qyzz',
        meta: {
          title: '单位资质',
          icon: 'el-icon-star-on'
        }
      },
      {
        path: '/Zrsqd',
        name: 'Zrsqd',
        component: 'Zrsqd',
        meta: {
          title: '责任书签订',
          icon: 'el-icon-star-on'
        }
      }
    ]
  },
  {
    path: '/',
    component: 'Home',
    meta: {
      title: '许可证管理',
      icon: 'iconfont icon-idcard2-fill'
    },
    hidden: false,
    leaf: false,
    children: [

      {
        path: '/Yssq',
        name: 'Yssq',
        component: 'Yssq',
        meta: {
          title: '运输申请',
          icon: 'el-icon-star-on'
        }
      },
      {
        path: '/Gmsq',
        name: 'Gmsq',
        component: 'Gmsq',
        meta: {
          title: '购买申请',
          icon: 'el-icon-star-on'
        }
      },
      {
        path: '/Tjhc',
        component: 'Tjhc',
        meta: {
          title: '调剂申请',
          icon: 'el-icon-star-on'
        }
      },
      {
        path: '/Yplyzdhxphc',
        component: 'Yplyzdhxphc',
        meta: {
          title: '药品类易制毒化学品核查',
          icon: 'el-icon-star-on'
        }
      },
      {
        path: '/Jkhc',
        component: 'Jkhc',
        meta: {
          title: '进口核查',
          icon: 'el-icon-star-on'
        }
      },
      {
        path: '/Hhwhc',
        component: 'Hhwhc',
        meta: {
          title: '混合物核查',
          icon: 'el-icon-star-on'
        }
      },
      {
        path: '/gmzlr',
        name: 'Gmzlr',
        component: 'gmzlr',
        meta: {
          title: '购买证录入',
          icon: 'el-icon-star-on'
        }
      },
      // {
      //     path: '/lrtjz',
      //     component: 'Lrtjz',
      //     meta: {
      //         title: '调剂证录入',
      //         icon: 'el-icon-star-on',
      //     }
      // },
      {
        path: '/lrypz',
        component: 'Lrypz',
        meta: {
          title: '药品证录入',
          icon: 'el-icon-star-on'
        }
      },
      {
        path: '/lrjkz',
        component: 'Lrjkz',
        meta: {
          title: '进口许可证录入（两用）',
          icon: 'el-icon-star-on'
        }
      }
      // {
      //     path: '/lrjkzw',
      //     component: 'Lrjkzw',
      //     meta: {
      //         title: '进口证明录入（外）',
      //         icon: 'el-icon-star-on',
      //     }
      // },
    ]
  },
  {
    path: '/',
    component: 'Home',
    meta: {
      title: '通知提醒',
      icon: 'iconfont icon-tongzhi'
    },
    hidden: false,
    leaf: false,
    children: [
      {
        path: '/Gmxkzwsytx',
        component: 'Gmxkzwsytx',
        meta: {
          title: '购买许可证（备案）未使用提醒',
          icon: 'el-icon-star-on'
        }
      },
      {
        path: '/Ysxkzwsytx',
        component: 'Ysxkzwsytx',
        meta: {
          title: '运输许可证（备案）未使用提醒',
          icon: 'el-icon-star-on'
        }
      },
      {
        path: '/Zjhx',
        component: 'Zjhx',
        meta: {
          title: '证件核销',
          icon: 'el-icon-star-on'
        }
      },
      {
        path: '/Qyzzdqtx',
        component: 'Qyzzdqtx',
        meta: {
          title: '单位资质到期提醒',
          icon: 'el-icon-star-on'
        }
      },

      {
        path: '/Zrsdqtx',
        component: 'Zrsdqtx',
        meta: {
          title: '责任书到期提醒',
          icon: 'el-icon-star-on'
        }
      }
    ]
  },
  {
    path: '/',
    component: 'Home',
    meta: {
      title: '入库管理',
      icon: 'iconfont icon-ruku'
    },
    hidden: false,
    leaf: false,
    children: [
      {
        path: '/Scrk',
        component: 'Scrk',
        meta: {
          title: '生产入库',
          icon: 'el-icon-star-on'
        }
      },
      {
        name: 'Gmrk',
        path: '/Gmrk',
        component: 'Gmrk',
        meta: {
          title: '购买入库',
          icon: 'el-icon-star-on'
        }
      },
      {
        path: '/Thrk',
        component: 'Thrk',
        meta: {
          title: '退货入库',
          icon: 'el-icon-star-on'
        }
      },
      {
        path: '/Nbsy',
        component: 'Nbsy',
        meta: {
          title: '内部使用退回',
          icon: 'el-icon-star-on'
        }
      },
      {
        path: '/Zyrk',
        component: 'Zyrk',
        meta: {
          title: '增溢入库',
          icon: 'el-icon-star-on'
        }
      },
      {
        path: '/Tjrk',
        component: 'Tjrk',
        meta: {
          title: '调剂入库',
          icon: 'el-icon-star-on'
        }
      },

      {
        path: '/Jkrk',
        component: 'Jkrk',
        meta: {
          title: '进口入库',
          icon: 'el-icon-star-on'
        }
      },

      {
        path: '/Qtrk',
        component: 'Qtrk',
        meta: {
          title: '其它入库',
          icon: 'el-icon-star-on'
        }
      },
      {
        path: '/Qtck',
        component: 'Qtck',
        meta: {
          title: '其它出库',
          icon: 'el-icon-star-on'
        }
      }
    ]
  },
  {
    path: '/',
    component: 'Home',
    meta: {
      title: '出库管理',
      icon: 'iconfont icon-yuchuku'
    },
    hidden: false,
    leaf: false,
    children: [
      {
        path: '/Xsck',
        component: 'Xsck',
        meta: {
          title: '销售出库',
          icon: 'el-icon-star-on'
        }
      },
      {
        path: '/Syck',
        component: 'Syck',
        meta: {
          title: '使用出库',
          icon: 'el-icon-star-on'
        }
      },
      {
        path: '/Thck',
        component: 'Thck',
        meta: {
          title: '退货出库',
          icon: 'el-icon-star-on'
        }
      },
      {
        path: '/Ykbb',
        component: 'Ykbb',
        meta: {
          title: '移库报备',
          icon: 'el-icon-star-on'
        }
      },
      {
        name: 'Ysbb',
        path: '/Ysbb',
        component: 'Ysbb',
        meta: {
          title: '运输报备',
          icon: 'el-icon-star-on'
        }
      },
      {
        path: '/Shck',
        component: 'Shck',
        meta: {
          title: '损耗出库',
          icon: 'el-icon-star-on'
        }
      },

      {
        path: '/Tjck',
        component: 'Tjck',
        meta: {
          title: '调剂出库',
          icon: 'el-icon-star-on'
        }
      },
      {
        path: '/Ckck',
        component: 'Ckck',
        meta: {
          title: '出口出库',
          icon: 'el-icon-star-on'
        }
      },
      {
        path: '/Qtck',
        component: 'Qtck',
        meta: {
          title: '其它出库',
          icon: 'el-icon-star-on'
        }
      }
    ]
  },

  {
    path: '/',
    component: 'Home',
    meta: {
      title: '信息核查',
      icon: 'iconfont icon-hecha-xiangxixuanzhong'
    },
    hidden: false,
    leaf: false,
    children: [
      {
        path: '/Dwhc',
        component: 'Dwhc',
        meta: {
          title: '单位核查',
          icon: 'el-icon-star-on'
        }
      },
      {
        path: '/Zshc',
        component: 'Zshc',
        meta: {
          title: '证书核查',
          icon: 'el-icon-star-on'
        }
      }
    ]
  },
  {
    path: '/',
    component: 'Home',
    meta: {
      title: '仓储管理',
      icon: 'iconfont icon-yunshuzhongwuliu'
    },
    hidden: false,
    leaf: false,
    children: [

      {
        path: '/Ccrk',
        component: 'Ccrk',
        meta: {
          title: '仓储入库',
          icon: 'el-icon-star-on'
        }
      },
      {
        path: '/Ccck',
        component: 'Ccck',
        meta: {
          title: '仓储出库',
          icon: 'el-icon-star-on'
        }
      },
      {
        path: '/Ccsy',
        component: 'Ccsy',
        meta: {
          title: '仓储损溢',
          icon: 'el-icon-star-on'
        }
      },
      {
        path: '/Cckc',
        component: 'Cckc',
        meta: {
          title: '仓储库存',
          icon: 'el-icon-star-on'
        }
      }
    ]
  },
  {
    path: '/',
    component: 'Home',
    meta: {
      title: '库存管理',
      icon: 'iconfont icon-kucunxiangqing'
    },
    hidden: false,
    leaf: false,
    children: [
      {
        path: '/Kccsh',
        component: 'Kccsh',
        meta: {
          title: '库存初始化',
          icon: 'el-icon-star-on'
        }
      },
      {
        path: '/Kcgl',
        component: 'Kcgl',
        meta: {
          title: '库存管理',
          icon: 'el-icon-star-on'
        }
      }
    ]
  },
  {
    path: '/',
    component: 'Home',
    meta: {
      title: '单位台账',
      icon: 'iconfont icon-taizhang_fill'
    },
    hidden: false,
    leaf: false,
    children: [

      {
        path: '/Tzscrk',
        component: 'Tzscrk',
        meta: {
          title: '生产入库',
          icon: 'el-icon-star-on'
        }
      },
      {
        path: '/Tzgmrk',
        component: 'Tzgmrk',
        meta: {
          title: '购买入库',
          icon: 'el-icon-star-on'
        }
      },
      {
        path: '/Tzxsck',
        component: 'Tzxsck',
        meta: {
          title: '销售出库',
          icon: 'el-icon-star-on'
        }
      },
      {
        path: '/Tzsyck',
        component: 'Tzsyck',
        meta: {
          title: '使用出库',
          icon: 'el-icon-star-on'
        }
      },
      {
        path: '/Tzqtrk',
        component: 'Tzqtrk',
        meta: {
          title: '其他入库',
          icon: 'el-icon-star-on'
        }
      },
      {
        path: '/Tzqtck',
        component: 'Tzqtck',
        meta: {
          title: '其他出库',
          icon: 'el-icon-star-on'
        }
      }
    ]
  },
  {
    path: '/',
    component: 'Home',
    meta: {
      title: '统计报表',
      icon: 'iconfont icon-tongji'
    },
    hidden: false,
    leaf: false,
    children: [
      {
        path: '/Hxpcrktj',
        component: 'Hxpcrktj',
        meta: {
          title: '化学品出入库统计',
          icon: 'el-icon-star-on'
        }
      },
      {
        path: '/Cchxpcrksj',
        component: 'Cchxpcrksj',
        meta: {
          title: '仓储化学品出入库统计',
          icon: 'el-icon-star-on'
        }
      },
      {
        path: '/Cckctj',
        component: 'Cckctj',
        meta: {
          title: '仓储库存统计',
          icon: 'el-icon-star-on'
        }
      },

      {
        path: '/Kfkctj',
        component: 'Kfkctj',
        meta: {
          title: '库房库存统计',
          icon: 'el-icon-star-on'
        }
      },
      {
        path: '/Hxpxsgmtj',
        component: 'Hxpxsgmtj',
        meta: {
          title: '销售/购买化学品统计',
          icon: 'el-icon-star-on'
        }
      }

    ]
  },

  {
    path: '/',
    component: 'Home',
    meta: {
      title: '信息互动',
      icon: 'iconfont icon-xinxifill'
    },
    hidden: false,
    leaf: false,
    children: [
      {
        path: '/Tzgg',
        component: 'Tzgg',
        meta: {
          title: '通知公告',
          icon: 'el-icon-star-on'
        }
      },
      {
        path: '/Flfg',
        component: 'Flfg',
        meta: {
          title: '法律法规',
          icon: 'el-icon-star-on'
        }
      },
      {
        path: '/Zcwj',
        component: 'Zcwj',
        meta: {
          title: '政策文件',
          icon: 'el-icon-star-on'
        }
      },
      {
        path: '/Qyjybg',
        component: 'Qyjybg',
        meta: {
          title: '企业经营报告',
          icon: 'el-icon-star-on'
        }
      }
    ]
  },
  {
    path: '/',
    component: 'Home',
    meta: {
      title: '公安考核项',
      icon: 'iconfont icon-xitong'
    },
    hidden: false,
    leaf: false,
    children: [
      {
        path: '/ExportCqxkz',
        component: 'ExportCqxkz',
        meta: {
          title: '导出超期许可证',
          icon: 'el-icon-star-on'
        }
      },
      {
        path: '/XkzBgfqkTj',
        component: 'XkzBgfqkTj',
        meta: {
          title: '导出许可证不规范情况',
          icon: 'el-icon-star-on'
        }
      },
      {
        path: '/GakhYjxgqkTj',
        component: 'GakhYjxgqkTj',
        meta: {
          title: '导出预警处置情况',
          icon: 'el-icon-star-on'
        }
      },
      {
        path: '/XkzHchxTj',
        component: 'XkzHchxTj',
        meta: {
          title: '许可证核查核销情况',
          icon: 'el-icon-star-on'
        }
      },
      ]
  },
  ,

  {
    path: '/',
    component: 'Home',
    meta: {
      title: '追溯码管理',
      icon: 'iconfont icon-tongji'
    },
    hidden: false,
    leaf: true, // 只有一个节点
    children: [
      {
        path: '/Zsmgl',
        component: 'Zsmgl',
        meta: {
          title: '追溯码管理',
          icon: 'iconfont icon-gongzuotai'
        }
      }
    ]
  },
  {
    path: '/',
    component: 'Home',
    meta: {
      title: '系统管理',
      icon: 'iconfont icon-xitong'
    },
    hidden: false,
    leaf: false,
    children: [
      {
        path: '/KfhcGmz',
        component: 'KfhcGmz',
        meta: {
          title: '核查购买证',
          icon: 'el-icon-star-on'
        }
      },
      {
        path: '/YyjZsxxData',
        component: 'YyjZsxxData',
        meta: {
          title: '预警证书信息',
          icon: 'el-icon-star-on'
        }
      },
      {
        path: '/DwhxpAndYwslTj',
        component: 'DwhxpAndYwslTj',
        meta: {
          title: '单位化学品业务数量统计',
          icon: 'el-icon-star-on'
        }
      },
      {
        path: '/GmzAndYszxx',
        component: 'GmzAndYszxx',
        meta: {
          title: '证书核查',
          icon: 'el-icon-star-on'
        }
      },
      {
        path: '/SysBgCrk',
        component: 'SysBgCrk',
        meta: {
          title: '系统变更出入库',
          icon: 'el-icon-star-on'
        }
      },
      {
        path: '/GlyRemoveDwxx',
        component: 'GlyRemoveDwxx',
        meta: {
          title: '删除入网单位',
          icon: 'el-icon-star-on'
        }
      },
      {
        path: '/DeptMerge',
        component: 'DeptMerge',
        meta: {
          title: '部门合并迁移',
          icon: 'el-icon-star-on'
        }
      },
      {
        path: '/XqCrkTjsl',
        component: 'XqCrkTjsl',
        meta: {
          title: '辖区出入库总量',
          icon: 'el-icon-star-on'
        }
      },
      {
        path: '/XqkczlData',
        component: 'XqkczlData',
        meta: {
          title: '辖区库存总量',
          icon: 'el-icon-star-on'
        }
      },
      {
        path: '/XzqhLxfs',
        component: 'XzqhLxfs',
        meta: {
          title: '行政区划联系方式',
          icon: 'el-icon-star-on'
        }
      },
      {
        path: '/GmzHqsjfxTable',
        component: 'GmzHqsjfxTable',
        meta: {
          title: '行情数据Table分析',
          icon: 'el-icon-star-on'
        }
      },
      {
        path: '/GmzHqsjfx',
        component: 'GmzHqsjfx',
        meta: {
          title: '行情数据分析',
          icon: 'el-icon-star-on'
        }
      },
      {
        path: '/SysYjczExport',
        component: 'SysYjczExport',
        meta: {
          title: '导出预警处置数据',
          icon: 'el-icon-star-on'
        }
      },
      {
        path: '/SysYczRyjExport',
        component: 'SysYczRyjExport',
        meta: {
          title: '导出已处置仍预警数据',
          icon: 'el-icon-star-on'
        }
      },
      {
        path: '/GmzGxhtxx',
        component: 'GmzGxhtxx',
        meta: {
          title: '购买证购销合同信息',
          icon: 'el-icon-star-on'
        }
      },
      {
        path: '/DwPzvip',
        component: 'DwPzvip',
        meta: {
          title: '单位配置Vip',
          icon: 'el-icon-star-on'
        }
      },
      {
        path: '/Tyshxydm',
        component: 'Tyshxydm',
        meta: {
          title: '统一社会信用代码修改',
          icon: 'el-icon-star-on'
        }
      },
      {
        path: '/Zczhcx',
        component: 'Zczhcx',
        meta: {
          title: '注册账号查询',
          icon: 'el-icon-star-on'
        }
      },
      {
        path: '/DwxxCxxq',
        component: 'DwxxCxxq',
        meta: {
          title: '单位信息查询详情',
          icon: 'el-icon-star-on'
        }
      },
      {
        path: '/Resetpwd',
        component: 'Resetpwd',
        meta: {
          title: '重置账号密码',
          icon: 'el-icon-star-on'
        }
      },
      {
        path: '/Yjpz',
        component: 'Yjpz',
        meta: {
          title: '预警配置',
          icon: 'el-icon-star-on'
        }
      },
      {
        path: '/CxSplcSl',
        component: 'CxSplcSl',
        meta: {
          title: '查询审批部门',
          icon: 'el-icon-star-on'
        }
      },
      {
        path: '/Cxgaxx',
        component: 'Cxgaxx',
        meta: {
          title: '查询公安信息',
          icon: 'el-icon-star-on'
        }
      },
      {
        path: '/SplcPzym',
        component: 'SplcPzym',
        meta: {
          title: '审批流程配置',
          icon: 'el-icon-star-on'
        }
      },
      {
        path: '/HolidyPz',
        component: 'HolidyPz',
        meta: {
          title: '超期假期配置',
          icon: 'el-icon-star-on'
        }
      },
      {
        path: '/Xzqh',
        component: 'Xzqh',
        meta: {
          title: '行政区划',
          icon: 'el-icon-star-on'
        }
      },

      {
        path: '/Bmgl',
        component: 'Bmgl',
        meta: {
          title: '部门管理',
          icon: 'el-icon-star-on'
        }
      },
      {
        path: '/Cdgl',
        component: 'Cdgl',
        meta: {
          title: '菜单管理',
          icon: 'el-icon-star-on'
        }
      },
      {
        path: '/Jsgl',
        component: 'Jsgl',
        meta: {
          title: '角色管理',
          icon: 'el-icon-star-on'
        }
      },
      {
        path: '/Yhgl',
        component: 'Yhgl',
        meta: {
          title: '用户管理',
          icon: 'el-icon-star-on'
        }
      },
      {
        path: '/Zdgl',
        component: 'Zdgl',
        meta: {
          title: '字典管理',
          icon: 'el-icon-star-on'
        }
      },
      {
        path: '/Czrz',
        component: 'Czrz',
        meta: {
          title: '操作日志',
          icon: 'el-icon-star-on'
        }
      },
      {
        path: '/Dlrz',
        component: 'Dlrz',
        meta: {
          title: '登录日志',
          icon: 'el-icon-star-on'
        }
      },
      {
        path: '/GabDlrz',
        component: 'GabDlrz',
        meta: {
          title: '部平台登录日志',
          icon: 'el-icon-star-on'
        }
      },
      {
        path: '/Zxrs',
        component: 'Zxrs',
        meta: {
          title: '在线人数',
          icon: 'el-icon-star-on'
        }
      },
      {
        path: '/Hxpgl',
        component: 'Hxpgl',
        meta: {
          title: '化学品管理',
          icon: 'el-icon-star-on'
        }
      },
      {
        path: '/Qtgl',
        component: 'Qtgl',
        meta: {
          title: '其它管理',
          icon: 'el-icon-star-on'
        }
      },
      {
        path: '/Hxwhc',
        component: 'Hxwhc',
        meta: {
          title: '购买证核销未核查',
          icon: 'el-icon-star-on'
        }
      },
      {
        path: '/Tg',
        component: 'Tg',
        meta: {
          title: '推广',
          icon: 'el-icon-star-on'
        }
      },
      {
        path: '/Bzgmxsys',
        component: 'Bzgmxsys',
        meta: {
          title: '本证购买销售运输',
          icon: 'el-icon-star-on'
        }
      },
      {
        path: '/Friday',
        component: 'Friday',
        meta: {
          title: '周五统计',
          icon: 'el-icon-star-on'
        }
      },
      {
        path: '/SysCxYjxq',
        component: 'SysCxYjxq',
        meta: {
          title: '预警信息查询',
          icon: 'el-icon-star-on'
        }
      },
      {
        path: '/Ckhc',
        component: 'Ckhc',
        meta: {
          title: '出口核查',
          icon: 'el-icon-star-on'
        }
      },
      {
        path: '/Jkfill',
        component: 'Jkfill',
        meta: {
          title: '进口核查',
          icon: 'el-icon-star-on'
        }
      },
      {
        path: '/Dwzjgqtx',
        component: 'Dwzjgqtx',
        meta: {
          title: '单位证件过期提醒',
          icon: 'el-icon-star-on'
        }
      },
    ]
  }
]
